import { render, staticRenderFns } from "./taskmanagement.vue?vue&type=template&id=13fb1788&scoped=true&"
import script from "./taskmanagement.vue?vue&type=script&lang=js&"
export * from "./taskmanagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb1788",
  null
  
)

export default component.exports